import { IUserExportFilters } from '@pepperhq/types-sdk';
import { IOperationV2 } from 'components/operation/models/OperationModel';

export type ICustomerExportFilters = IUserExportFilters;

export interface ICreateCustomerExportOptions {
    filters?: ICustomerExportFilters;
}

interface ICustomerExportOperationResult {
    exported: number;
    total: number;
    errors: number;
    href?: string;
    etaMs: number;
    message: string;
}

interface ICustomerExportOperationError {
    code: string;
    message: string;
    isRetryable: boolean;
}

export interface ICustomerExportOperation
    extends IOperationV2<
        string,
        ICreateCustomerExportOptions,
        ICustomerExportOperationResult,
        ICustomerExportOperationError
    > {
    namespace: 'USERS';
    name: 'USER_EXPORT';
}

export interface IGetCustomerOperationsParams {
    nextKey?: string;
}

export const CUSTOMER_OPERATIONS_LIMIT = 100;

export const INITIAL_OPERATION_RESULT = {
    total: 0,
    exported: 0,
    errors: 0,
    message: 'Creating export'
};
